import { Reveal } from "@/components/Reveal";

const tenets = [
    {
        numeral: "I",
        title: "Uncompromising Quality",
        body: "Every frame held to a standard most studios never reach — color, cut, and sound refined until nothing ordinary remains.",
        testid: "studio-tenet-quality",
    },
    {
        numeral: "II",
        title: "Structured Precision",
        body: "A disciplined atelier pipeline — deliberate, transparent, and exact — from the first assembly to the final master.",
        testid: "studio-tenet-structure",
    },
    {
        numeral: "III",
        title: "Cinematic Mastery",
        body: "Not deliverables, but masterpieces — visual assets composed to carry the weight of a high-ticket brand.",
        testid: "studio-tenet-mastery",
    },
];

const Studio = () => (
    <section
        id="studio"
        data-testid="the-studio-section"
        className="relative overflow-hidden px-6 py-32 sm:py-40 lg:px-16 lg:py-52"
    >
        <div className="royal-flare absolute inset-x-0 top-0 h-[50vh] opacity-70" />

        <div className="relative mx-auto max-w-4xl text-center">
            <Reveal>
                <p className="mb-8 font-display text-[10px] uppercase tracking-[0.5em] text-[#270057]">
                    The Studio
                </p>
                <h2
                    data-testid="the-studio-statement"
                    className="font-serif text-3xl font-normal leading-snug tracking-[-0.01em] text-[#270057] sm:text-4xl lg:text-5xl lg:leading-[1.25]"
                >
                    We exist for brands that refuse the ordinary — where
                    structure replaces chaos, precision is absolute, and every
                    commission leaves the atelier as a{" "}
                    <em className="italic">cinematic masterpiece</em>.
                </h2>
            </Reveal>
        </div>

        <div className="relative mx-auto mt-28 grid max-w-6xl grid-cols-1 gap-14 md:grid-cols-3 lg:mt-36 lg:gap-16">
            {tenets.map((t, i) => (
                <Reveal key={t.numeral} delay={i * 0.15}>
                    <div
                        data-testid={t.testid}
                        className="group border-t border-[#270057]/20 pt-10 text-center transition-colors duration-700 hover:border-[#270057]/60"
                    >
                        <span className="font-serif text-2xl italic text-[#270057] transition-colors duration-700 group-hover:text-[#270057]">
                            {t.numeral}.
                        </span>
                        <h3 className="mt-6 font-serif text-2xl font-medium text-[#270057]">
                            {t.title}
                        </h3>
                        <p className="mt-5 text-base font-normal leading-relaxed text-[#270057]">
                            {t.body}
                        </p>
                    </div>
                </Reveal>
            ))}
        </div>
    </section>
);

export default Studio;
